import { PAYMENT_PLAN_TYPE } from "constants/schedule";
import React from "react";
import { Tooltip } from "@my-scoot/component-library-legacy";
import Info from "@material-ui/icons/InfoRounded";

export const DISCOUNT_PAYMENT_PLAN_TYPE = {
  ...PAYMENT_PLAN_TYPE,
  VARIATIONS: 4,
  ORDER_BUMPS: 5,
  LTO: 6,
  CUSTOM_PAYMENT_LINKS: 7,
};

export const discount_form_keys = {
  expiry: "expiry",
  discount_application_scope: "discount_application_scope",
  instalment_distribution_mechanism: "instalment_distribution_mechanism",
  usage_limit: "usage_limit",
};

export const instalment_discount_types = {
  BOTTOM_TO_TOP: 1,
  TOP_TO_BOTTOM: 2,
  EQUAL_DISTRIBUTION: 3,
  NEXT_SCHEDULED_INSTALMENT: 4,
};

export const discount_application_scope_options = [
  {
    label: "One-Time payments",
    value: DISCOUNT_PAYMENT_PLAN_TYPE.ONE_TIME_PAYMENT,
  },
  { label: "Instalments", value: DISCOUNT_PAYMENT_PLAN_TYPE.INSTALLMENTS },
  { label: "Subscriptions", value: DISCOUNT_PAYMENT_PLAN_TYPE.SUBSCRIPTIONS },
  {
    label: "Offering Variations",
    value: DISCOUNT_PAYMENT_PLAN_TYPE.VARIATIONS,
  },
  {
    label: "Order Bumps",
    value: DISCOUNT_PAYMENT_PLAN_TYPE.ORDER_BUMPS,
  },
  {
    label: "Limited time offer",
    value: DISCOUNT_PAYMENT_PLAN_TYPE.LTO,
  },
  {
    label: "Payment Links",
    value: DISCOUNT_PAYMENT_PLAN_TYPE.CUSTOM_PAYMENT_LINKS,
  },
];

export const instalment_discount_types_options = [
  {
    label: "Apply Discount only on the first Instalment being purchased",
    value: instalment_discount_types.NEXT_SCHEDULED_INSTALMENT,
  },
  {
    label: (
      <div className="tw-flex tw-items-center tw-gap-2">
        pply the highest possible discount starting from the first instalment
        and move forwards
        <Tooltip
          color="primary"
          arrow
          title="This method prioritizes reducing the earliest payments first"
        >
          <Info className="!tw-w-[18px] !tw-h-[18px]" />
        </Tooltip>
      </div>
    ),
    value: instalment_discount_types.TOP_TO_BOTTOM,
  },
  {
    label: (
      <div className="tw-flex tw-items-center tw-gap-2">
        Apply the highest possible discount starting from the final instalment
        and move backwards
        <Tooltip
          color="primary"
          arrow
          title="This method prioritizes reducing the last payments first"
        >
          <Info className="!tw-w-[18px] !tw-h-[18px]" />
        </Tooltip>
      </div>
    ),
    value: instalment_discount_types.BOTTOM_TO_TOP,
  },
  {
    label: "Distribute Discount amount evenly on all Instalments",
    value: instalment_discount_types.EQUAL_DISTRIBUTION,
  },
];

export const discount_editable_keys = [
  discount_form_keys.expiry,
  discount_form_keys.usage_limit,
];
